import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET } from '../../../services/rest.service';

const SitterRequests = () => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState({});

  const getPage = async (page) => {
    dispatch(showLoading());
    try {
      const { data } = await GET(`admin/family/sitter/requests/${page}`);
      setRecords(data.Requests);
      setPages(data.Pages);
      setTotal(data.Total);
      setCurrentPage(page);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };
  useEffect(() => {
    getPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markNewRequestsAsRead = async () => {
    try {
      await GET('admin/sitter/stats/reset');
      toast.success('Marked all requests as read ones');
      getPage(currentPage);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handlePageClick = (e) => {
    getPage(e.selected + 1);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRequest({});
  };

  const openDialog = (data) => {
    setOpen(true);
    setSelectedRequest(data);
  };

  return (
    <React.Fragment>
      <div className="container-fluid px-xl-5">
        <section className="py-5">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h6 className="text-uppercase mb-0">Sitter Requests</h6>

                  <Button variant="outlined" color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={markNewRequestsAsRead}>
                    Mark As Read
                  </Button>
                </div>
                <div className="card-body">
                  <table className="table card-text">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Requested On</th>
                        <th>Family Info</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Children</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((record, index) => {
                        return (
                          <tr key={index}>
                            <th scope="row">
                              {(currentPage - 1) * 20 + (index + 1)} {!record.is_read && <span className="badge badge-success">New!</span>}
                            </th>
                            <th>{record.created_at && moment(record.created_at).format('MM/DD/YYYY HH:mm A')}</th>
                            <td>
                              {record.user_id && !isEmpty(record.user_id) && (
                                <Link to={`/admin/family/view/${record.user_id._id}`}>
                                  {record.user_id.first_name}&nbsp;
                                  {record.user_id.last_name}
                                </Link>
                              )}
                            </td>
                            <td>{moment(record.needed_start_time).format('MM/DD/YYYY')}</td>
                            <td>{moment(record.needed_end_time).format('MM/DD/YYYY')}</td>
                            <td>
                              {record.no_of_children} / {record.children_age} year(s)
                            </td>
                            <td>{record.service_zipcode.address}</td>
                            <td>{record.status}</td>
                            <td>
                              <a href="#!" onClick={() => openDialog(record)}>
                                View Details
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="mx-auto my-4">
              <ReactPaginate
                previousLabel={'previous'}
                nextLabel={'next'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                nextClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextLinkClassName={'page-link'}
                pageClassName={'page-item'}
                onPageChange={handlePageClick}
              />
            </div>
          </div>
        </section>
      </div>
      <Dialog maxWidth={'lg'} open={open} onClose={handleClose} aria-labelledby="simple-dialog-title">
        <DialogTitle id="simple-dialog-title">Requested On {selectedRequest && moment(selectedRequest.created_at).format('MM/DD/YYYY')}</DialogTitle>
        {selectedRequest && (
          <div className="card">
            <div className={'card p-3 h-100 nannies-list'}>
              <div>
                <p>
                  <strong>Children's Age</strong>: {selectedRequest.children_age}
                </p>
                <p>
                  <strong>Have Pets?</strong>: {selectedRequest.do_have_pets}
                </p>
                <p>
                  <strong>Free Parking?</strong>: {selectedRequest.easy_free_parking}
                </p>
                <p>
                  <strong>End Time</strong>: {moment(selectedRequest.needed_end_time).format('MM/DD/YYYY')}
                </p>
                <p>
                  <strong>Start Time</strong>: {moment(selectedRequest.needed_start_time).format('MM/DD/YYYY')}
                </p>
                <p>
                  <strong>Number of children</strong>: {selectedRequest.no_of_children}
                </p>
                <p>
                  <strong>Start Date</strong>: {moment(selectedRequest.start_date).format('MM/DD/YYYY')}
                </p>
                <p>
                  <strong>Status</strong>: {selectedRequest.status}
                </p>
                <p>
                  <strong>How Transports Children</strong>: {selectedRequest.transport_children}
                </p>
                <p>
                  <strong>Types of Care</strong>: {selectedRequest.types_of_care}
                </p>
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default SitterRequests;
